import { useLayoutEffect } from "react";
import { useLocation } from "react-router";

/**
 * Hook to automatically scroll to the top of the page on route changes.
 * Preserves hash navigation behavior - does not scroll when the route has a hash fragment.
 *
 * @example
 * function App() {
 *   useScrollToTopOnPageChange();
 *   return <Routes>...</Routes>;
 * }
 */
const useScrollToTopOnPageChange = (): void => {
    const location = useLocation();

    useLayoutEffect(() => {
        // Don't interfere with routes with hashes
        if (!location.hash) {
            window.scroll(0, 0);
        }
    }, [location]);
};

export default useScrollToTopOnPageChange;